import React from 'react'
import "./Loading.css"

function Loading() {
  return (
    <div className="spinner-view">
      <div className="container-spinner">
          <div className='spinner'></div>
          <span className="text-spinner">Cargando...</span>
      </div>
    </div>
  );
}

export default Loading;
